import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AuroraBackground from '../components/AuroraBackground/AuroraBackground';
import AuroraNavbar from '../components/AuroraNavbar/AuroraNavbar';
import Footer from '../components/Footer';
import MetaHead from '../components/MetaHead';
import '../styles/pg-404.css';

export default function NotFound() {
  const { t } = useTranslation('common');

  return (
    <>
      <MetaHead page="notFound" />
      <AuroraBackground />
      <AuroraNavbar />

      <main className="pg-404">
        <div className="pg-404-inner">
          <span className="pg-404-num">404</span>
          <h1 className="pg-404-title">{t('notFound.title')}</h1>
          <p className="pg-404-desc">{t('notFound.subtitle')}</p>
          <div className="pg-404-cta-row">
            <Link to="/" className="pg-404-cta-primary">{t('notFound.cta_home')}</Link>
            <Link to="/dashboard" className="pg-404-cta-ghost">{t('notFound.cta_dashboard')}</Link>
          </div>
        </div>
      </main>

      <Footer />
    </>
  );
}
